import upsell from "../upsell"
import { TrackingManager } from "../../../../../lib/common/js/services/tracking/trackingManager"

export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),
  ...upsell("shopping_list"),
  
  internalTracker: new TrackingManager(
    window.trackingConfig.enabledTrackingServices,
    pipelineConfig,
  ),

  init() {
    this.commonInit()
  },

  onInit() {
    this.initUpsell()
  },

  handleOfferAccept() {
    this.internalTracker.trackClick({ clickName: "Shopping List Accepted Clicked" })
    this.purchase()
  },

  handleOfferDecline() {
    this.internalTracker.trackClick({ clickName: "Shopping List Rejected Clicked" })
    this.goToNextUpsellOffer(true)
  },
})
